import { CommonModule } from '@angular/common';
import { Component, HostListener, computed, inject, signal } from '@angular/core';
import { AccessibilityService } from '../../services/accessibility.service';

@Component({
  selector: 'mobilize-accessibility-toolbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accessibility-toolbar.component.html',
  styleUrl: './accessibility-toolbar.component.scss',
})
export class AccessibilityToolbarComponent {
  private readonly a11y = inject(AccessibilityService);

  readonly isOpen = signal(false);
  readonly settings = computed(() => this.a11y.settings);

  toggleOpen(): void {
    this.isOpen.update((v) => !v);
  }

  close(): void {
    this.isOpen.set(false);
  }

  reset(): void {
    this.a11y.reset();
  }

  increaseFont(): void {
    this.a11y.increaseFont();
  }

  decreaseFont(): void {
    this.a11y.decreaseFont();
  }

  toggle(key: 'grayscale' | 'negativeContrast' | 'highContrast' | 'lightBackground' | 'underlineLinks' | 'readableFont'): void {
    this.a11y.toggle(key);
  }

  @HostListener('document:keydown.escape')
  onEsc(): void {
    this.close();
  }
}

